import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import PersonOffIcon from '@mui/icons-material/PersonOff';
import Typography from "@mui/material/Typography";

export default function InactiveMembersCard({ numberOfMembers, isSelected, isMemberDrawerOpen, getMembers , inativeMembers }) {
  return (
    <Box>
      <Button
        color="carbonGray"
        onClick={ getMembers }
        disabled={ !isSelected }
        sx={{
          alignItems: "center",
          backgroundColor: !isSelected && "white",
          borderRadius: "40px",
          boxShadow: "0px 0px 15px 0px rgb(88 88 88 / 20%)",
          display: "flex",
          height: "144px",
          justifyContent: "space-around",
          padding: "12px 24px",
          width: "100%",
        }}
      >
        {
          !isMemberDrawerOpen
          ? (
            <>
              <PersonOffIcon color={!isSelected ? "error" : "disabled"} sx={{ display: { xs: "none", lg: "block" }, fontSize: "100px" }}/>
              <Box
                sx={{
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "column",
                  textAlign: "center",
                }}
              >
                <Typography
                  color={!isSelected ? "error" : "inherit"}
                  component="p"
                  sx={{ fontWeight: 600 }}
                  variant="h4"
                >
                  { inativeMembers }
                </Typography>
                <Typography sx={{ fontSize: '20px' }}>
                  USUÁRIOS INATIVOS
                </Typography>
              </Box>
            </>
          ) : (
            <Box
              sx={{
                alignItems: "center",
                display: "flex",
                flexDirection: "column",
                textAlign: "center",
              }}
            >
              <Typography
                component="p"
                sx={{ fontWeight: 600 }}
                variant="h4"
              >
                { inativeMembers }
              </Typography>
              <Typography sx={{ fontSize: '20px' }}>
                USUÁRIOS INATIVOS
              </Typography>
            </Box>
          )
        }
      </Button>
    </Box>
  );
};
